import styled from 'styled-components'

const TabGroup = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  column-gap: 12px;

  margin: auto;
  margin-bottom: 14px;
`

export function StatusTabGroup({ children }: { children: any }) {
  return <TabGroup>{children}</TabGroup>
}
